export function resizeImages() {
  const default_width = 250,
    target_area = Math.pow(default_width, 2);

  if (is_desktop()) {
    $(".creations img").each((_i, img) => {
      const $img = $(img),
        width = $img.width() ?? 0,
        height = $img.height() ?? 0,
        area = width * height;

      if (area !== 0) {
        $img
          .parents("article")
          .first()
          .css("max-width", width * Math.sqrt(target_area / area));
      }
    });
  } else {
    $(".creations img").each((_i, img) => {
      const $img = $(img);

      $img.parents("article").first().attr("style", null);
    });
  }
}

function is_desktop() {
  return window.innerWidth >= 860;
}
